import { Text, Box, VStack } from '@chakra-ui/react'
import Footer from '../components/Footer'
import CourseList from '../components/CourseList'


import ballet2 from '../assets/course2-4.jpg'
import ballet5 from '../assets/course5-7.jpg'
import ballet8 from '../assets/course8.jpg'
import moderny from '../assets/moderny.jpg'
import moderno from '../assets/modernold.jpg'
import stretching from '../assets/stretching.jpg'
import { useTranslation } from 'react-i18next'

const courses = [
  {
    title: 'courses.classicChildren',
    subTitle: 'courses.ages24',
    image: ballet2,
    href: '/ballet'
  },
  {
    title: 'courses.classicChildren',
    subTitle: 'courses.ages58',
    image: ballet5,
    href: '/ballet'
  },
  {
    title: 'courses.classicChildren',
    subTitle: 'courses.ages9',
    image: ballet8,
    href: '/ballet'
  },
  {
    title: 'courses.modernChildren',
    subTitle: 'courses.beginners',
    image: moderny,
    href: '/modern'
  },
  {
    title: 'courses.modernChildren',
    subTitle: 'courses.advanced',
    image: moderno,
    href: '/modern'
  },
  {
    title: 'courses.stretching',
    subTitle: 'courses.adults',
    image: stretching,
    href: '/stretching'
  },
]



const CoursePage = () => {
  const { t } = useTranslation()
  const translatedCourses = courses.map((course) => ({
    ...course,
    title: t(course.title),
    subTitle: t(course.subTitle),
  }))

  return (
    <>
        <Box
            bg={'#f5f5f7'}
            width={'100%'}
            position="relative"
            padding={{ base: '12vh 5vw 8vh', md: '12vh 5vw 10vh' }}
             >
                <VStack
                    width={'100%'}
                    maxW={'1180px'}
                    margin={'auto'}
                  >
                    <Text
                        fontSize={{ base: '3xl', md: '4xl' }}
                        fontFamily={'heading'}
                        fontWeight={'bold'}
                        padding={'2vh 0'}
                        textAlign="center"
                        >{t('courses.title')}</Text>
                        <Box
                          bg={'transparent'}
                          w={'100%'}
                          padding={'4vh 0 6vh'}>
                            <CourseList courses={translatedCourses}/>
                        </Box>

                </VStack>

        </Box>
        <Footer></Footer>

    </>
  )
}

export default CoursePage
